export const LOGIN_CONSTANTS = {
  PAGE_TITLE: "Bienvenido",
  MODAL_REDIRECT_TITLE: "Selecciona la plataforma a la que quieres acceder",
  LABEL: {
    USER: "Usuario",
    PASSWORD: "Contraseña",
    CONFIRM_PASSWORD: "Confirmar contraseña",
    NEW_PASSWORD: "Nueva contraseña",
    NEW_VALID_PASSWORD: "Confirmar nueva contraseña",
    EMAIL: "Correo electronico",
    ID: "Identificación"
  },
  BUTTON: {
    USER_PASSWORD: "Iniciar sesión",
    GOOGLE: "Continuar con Google",
    REGISTER: "¿Todavía no tienes una cuenta? ",
    SINGME: " Regístrate",
    FORGOT_PASSWORD: "¿Has olvidado tu contraseña?",
    RECOVERY_PASSWORD: "Recuperar contraseña",
    NEW_PASSWORD: "Ingresa tu nueva contraseña",
    SEND_CODE: "Enviar código",
    FORWARD_CODE: "Re-enviar Código",
    VALIDATE: "Validar código",
    RESET_PASSWORD: "Restablecer contraseña"
  },

  SNACKBAR: {
    RECAPCHAT_ERROR: "Error al validar el recaptcha",
    RECAPCHAT_NOT_COMPLETE: "Por favor complete el recaptcha",
    NOT_FOUND: "Usuario o contraseña incorrectos",
    EMPTY: "Debe ingresar un usuario y una contraseña",
    BAD_LOGIN: "Ha ocurrido un error al intentar iniciar sesión",
    WELCOME: "Bienvenido a Neumomed ",
    USER_NOT_FOUND: "Usuario no encontrado",
    OPT_NOT_FOUND: "Código de verificación invalido o expirado",
    OPT_DOCUMENT_NOT_FOUND: "Documento no encontrado o no valido",
    OPT_GOOGLE_NOT_ALLOW: "Servicio no disponible, intente más tarde"
  },
  APPOINTMENT_USER: "appointment",
  URL_TO_REGISTER: "/user/register",
  URL_LOGIN: "/login",
  ROLE_PATIENT: "PACIENTE",
  NEUMO_PLATFORM: "neumoPlatform",
  PATIENT_PORTAL: "patientPortal",
  PLATAFORMA_NEUMOMED: "plataforma neumomed",
  PLATAFORMA_PACIENTE: "plataforma doctor neumo",
  REMOVE_TOKEN: "TOKEN"
};

export const REGISTER_CONSTANS = {
  PAGE_TITLE: "Registro de Usuarios",
  CREATE_PASSWORD_TITLE: "Crear contraseña",
  APPOINTMENT_TITLE: "Consulta de citas",
  BUTTON: {
    REGISTER: "Registrarme",
    CONTINUE: "Continuar"
  },
  LABEL: {
    NAME: "Nombre completo*",
    EMAIL: "Correo electrónico",
    USER: "Documento de identidad*",
    PASSWORD: "Contraseña*",
    CONFIRM_PASS: "Confirmar contraseña*",
    ID: "Ingresa tu documento"
  },
  MESSAGE: {
    MIN_LENGTH: "La contraseña debe contener al menos 8 caracteres",
    MATCH_PASS: "Las constraseñas no coinciden",
    FORWARD_SEND_CODE: "Se ha reenviado el código de confirmación",
    SMS_SENT:
      "Se ha enviado el código de confirmación al número de celular con terminación",
    LINK_NOT_VALID: "Enlace no valido",
    SAVED_USER:
      "Usuario registrado, recuerde que el usuario es el documento de identidad",
    CONFIRM_MESSAGE: "Mensaje de confirmación pronto llegara a su celular",
    ERROR_RETRY: "Ha ocurrido un error, intente más tarde",
    CONFIRM_MESSAGE_ID:
      "Coloca tú cédula para enviar un sms con un código de confirmación para validar tu identidad y posterior restablecer la contraseña."
  }
};

export const GOOGLE_PROVIDER_PARAMS = {
  prompt: "select_account"
};

export const AUTH_ACCESS = {
  GENERAL: "realizar esta acción"
};

export const WELCOME_MSG = "Bienvenido a Neumomed, inicia tu sesión:";

export const EMMITER_EVENT = {
  CLOSE_DIALOG: "close-dialog"
};

export const GOOGLE_AUTH = {
  CODE_INVALID: "auth/invalid-verification-code"
};
